import React, { useEffect, useState } from "react";
import Sign from "./Sign";
import PrimaryButton from "../buttons/PrimaryButton";
import Modal1 from "../modals/Modal1";
import getTemporaryUrl from "../api/getTemporaryUrl";
import { getDocDataByRef } from "../models/DataFunctions";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken";
import SmallSpinner from "../loading/SmallSpinner";

const SignModal = ({
  document,
  children,
  folder,
  orgData,
  userData,
  setModalOpen,
  onUpdate,
  overrideId,
  prefix,
  navigateWorkspace,
}) => {
  const [open, setOpen] = useState(false);
  const [signopen, setSignOpen] = useState(false);
  const [folderData, setFolderData] = useState(null);
  const [loadingUrl, setLoadingUrl] = useState(false);

  const handleOpen = async (e) => {
    setLoadingUrl(true);
    const token = await getOrRefreshFirebaseToken();
    await getTemporaryUrl(token, "doc", document.id, folder.id, prefix, null);
    let folderData = await getDocDataByRef(folder.ref);
    setFolderData(folderData);

    e.stopPropagation();
    setOpen(true);
    setModalOpen(true); // Notify parent that modal is open
    setLoadingUrl(false);
  };

  const handleFetchAgain = (id) => {
    setOpen(false);
    setModalOpen(false); // Notify parent that modal is closed
    onUpdate(); // Assuming you have this onDelete function
  };

  const handleClose = () => {
    setOpen(false);
    setModalOpen(false); // Notify parent that modal is closed
  };

  return (
    document && (
      <div className="w-full h-full justify-center items-center align-middle bg-transparent">
        {/* Button to open the modal */}
        <div className="h-fit w-fit cursor-pointer bg-transparent">
          <PrimaryButton
            onClick={handleOpen}
            disabled={!document.viewers_id?.includes(orgData.id)}
            sx={{
              fontSize: "13px",
              borderRadius: "8px",
              minWidth: "80px",
            }}
          >
            Signer
            <SmallSpinner loading={loadingUrl} />
          </PrimaryButton>
          {children}
        </div>
        {open && (
          <div className="flex flex-col items-center justify-center">
            <Modal1 isOpen={open && folderData} onClose={handleClose}>
              <Sign
                document={document}
                folder={folderData}
                orgData={orgData}
                userData={userData}
                onClose={handleFetchAgain}
                onDelete={handleFetchAgain}
                overrideId={overrideId}
                prefix={prefix}
                navigateWorkspace={navigateWorkspace}
              />
            </Modal1>
          </div>
        )}
      </div>
    )
  );
};

export default SignModal;
